"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.imagePropType = exports.extraLayerPropType = exports.dataPropType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var imagePropType = _propTypes["default"].shape({
  image: _propTypes["default"].string,
  altText: _propTypes["default"].string
});

exports.imagePropType = imagePropType;

var extraLayerPropType = _propTypes["default"].shape({
  image: imagePropType
});

exports.extraLayerPropType = extraLayerPropType;

var dataPropType = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  items: _propTypes["default"].arrayOf(extraLayerPropType)
});

exports.dataPropType = dataPropType;